const FINISH_TIMEOUT_MS = 5_000;

/**
 * Tracks one outstanding "Finish" request. The server confirms by moving this
 * participant to finished or the room to results; a silent timeout releases the
 * control with an explanation instead of leaving it stuck.
 */
export class FinishParticipation {
  finishing = $state(false);
  error = $state('');
  private request = 0;
  private identity = '';

  /** Start tracking; `send` returns whether the command left the socket. */
  begin(identity: string, send: () => boolean): void {
    const request = ++this.request;
    this.identity = identity;
    this.finishing = true;
    this.error = '';
    if (!send()) {
      this.finishing = false;
      this.error = 'Could not send Finish. Reconnect and try again.';
      return;
    }
    window.setTimeout(() => {
      if (this.finishing && request === this.request) {
        this.finishing = false;
        this.error = 'Finish was not confirmed. Try again.';
      }
    }, FINISH_TIMEOUT_MS);
  }

  /** Called whenever the observed participation changes; clears when confirmed or superseded. */
  observe(input: { identity: string; finished: boolean; resultsShown: boolean }): void {
    if (input.finished || input.resultsShown || this.identity !== input.identity) {
      this.finishing = false;
      this.error = '';
    }
  }
}
